// @file Entrypoint for auth login page
import { captureException } from '@@/bits/error_tracker'
import { ww } from '@@/bits/global'
import { setupVueApp } from '@@/bits/vue'
import { useAuthLoginStore } from '@@/pinia/auth_login_store'
import AuthLoginApp from '@@/vuecomponents/AuthLoginApp.vue'

void setupVueApp({
  el: '#auth_login_app',
  rootComponent: AuthLoginApp,
  usePinia: true,
  initializePiniaStore() {
    void useAuthLoginStore().initialize(ww.vueStartingState)
  },
}).catch(captureException)
